export const desktopNavigation = () => {
    const desktopNavigationContainer = document.querySelector('.js-desktop-navigation-container');
    const desktopNavigationBackdrop = document.querySelector('.js-desktop-navigation-backdrop');
    if (!desktopNavigationContainer || !desktopNavigationBackdrop) return;
    const toggles = [...document.querySelectorAll('.js-desktop-navigation-toggle')];
    const menus = [...document.querySelectorAll('.js-desktop-navigation-menu')];

    if (!desktopNavigationContainer) {
        return;
    }

    let showTimeout = null;
    let hideTimeout = null;
    let activeMenu = null;

    const setExpanded = (toggle, expanded) => {
        toggle.setAttribute('aria-expanded', expanded);
        const menu = document.getElementById(toggle.getAttribute('aria-controls'));
        if (menu) menu.hidden = !expanded;
    };

    const isFocusInsideNav = () => desktopNavigationContainer.contains(document.activeElement);

    const focusFirstItem = (menu, fromBottom = false) => {
        const items = [
            ...menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'),
        ].filter((el) => !el.disabled && !el.getAttribute('aria-hidden'));
        if (!items.length) return;
        (fromBottom ? items.at(-1) : items[0]).focus();
    };

    const hideActiveMenu = () => {
        if (!activeMenu) return;
        const toggle = document.querySelector(`[aria-controls="${activeMenu.id}"]`);
        setExpanded(toggle, false);
        activeMenu.classList.remove('is-active');
        activeMenu = null;
        desktopNavigationBackdrop.classList.remove('is-active');
    };

    const activateMenu = (slug, focusInside = false, fromBottom = false) => {
        clearTimeout(hideTimeout);
        if (activeMenu) hideActiveMenu();
        const menu = menus.find((m) => m.dataset.componentName === slug);
        const toggle = document.querySelector(
            `.js-desktop-navigation-toggle[data-component-name="${slug}"]`
        );
        if (!menu || !toggle) return;

        desktopNavigationBackdrop.classList.add('is-active');
        menu.classList.add('is-active');
        setExpanded(toggle, true);
        activeMenu = menu;

        if (focusInside) focusFirstItem(menu, fromBottom);
    };

    toggles.forEach((toggle, i) => {
        toggle.addEventListener('mouseenter', () => {
            clearTimeout(showTimeout);
            showTimeout = setTimeout(() => activateMenu(toggle.dataset.componentName), 100);
        });
        toggle.addEventListener('mouseleave', () => clearTimeout(showTimeout));

        toggle.addEventListener('focus', () => activateMenu(toggle.dataset.componentName));
        toggle.addEventListener('keydown', (e) => {
            const { key } = e;

            if (key === 'ArrowRight' || key === 'ArrowLeft') {
                e.preventDefault();
                const dir = key === 'ArrowRight' ? 1 : -1;
                const next = toggles[(i + dir + toggles.length) % toggles.length];
                next.focus();
                return;
            }

            if (key === 'ArrowDown') {
                e.preventDefault();
                activateMenu(toggle.dataset.componentName, true);
                return;
            }

            if (key === 'ArrowUp') {
                e.preventDefault();
                activateMenu(toggle.dataset.componentName, true, true);
                return;
            }

            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                const expanded = toggle.getAttribute('aria-expanded') === 'true';
                if (expanded) {
                    hideActiveMenu();
                } else {
                    activateMenu(toggle.dataset.componentName);
                }
                return;
            }

            if (key === 'Escape') {
                e.preventDefault();
                hideActiveMenu();
            }
        });
    });

    /* eslint-disable indent */
    menus.forEach((menu) => {
        menu.addEventListener('keydown', (e) => {
            const items = [
                ...menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'),
            ].filter((el) => !el.disabled && !el.getAttribute('aria-hidden'));

            const idx = items.indexOf(document.activeElement);

            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    items[(idx + 1) % items.length].focus();
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    items[(idx - 1 + items.length) % items.length].focus();
                    break;
                case 'Home':
                    e.preventDefault();
                    items[0].focus();
                    break;
                case 'End':
                    e.preventDefault();
                    items.at(-1).focus();
                    break;
                case 'Escape':
                    e.preventDefault();
                    hideActiveMenu();
                    document.querySelector(`[aria-controls="${menu.id}"]`).focus();
                    break;
                case 'ArrowRight':
                case 'ArrowLeft': {
                    e.preventDefault();
                    const dir = e.key === 'ArrowRight' ? 1 : -1;
                    const currentToggle = document.querySelector(`[aria-controls="${menu.id}"]`);
                    const currentIndex = toggles.indexOf(currentToggle);
                    const nextToggle =
                        toggles[(currentIndex + dir + toggles.length) % toggles.length];
                    nextToggle.focus();
                    break;
                }
                default:
                    break;
            }
        });
    });
    /* eslint-enable indent */

    desktopNavigationContainer.addEventListener('mouseenter', () => clearTimeout(hideTimeout));
    desktopNavigationContainer.addEventListener('mouseleave', () => {
        if (isFocusInsideNav()) return;
        hideTimeout = setTimeout(hideActiveMenu, 300);
    });
    desktopNavigationBackdrop.addEventListener('mouseenter', () => {
        if (isFocusInsideNav()) return;
        hideTimeout = setTimeout(hideActiveMenu, 300);
    });
};
